mutation PauseDripSequence($input: DripSequencePauseInput!) {
    dripSequencePause(input: $input) {
        dripSequence {
            id
        }
    }
}
